import { all, fork, put, takeEvery } from "@redux-saga/core/effects";
import AxiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";
import { ADD_DEPT_URL, GET_DEPT_URL, UPD_DEPT_URL } from "./constants";
import store from "../../store";
import { REACT_APP_USER_SERVICE_URL } from "../../../urls";

function* getAllDepartments() {
  let response;
  try {
    response = yield AxiosInstance.get(REACT_APP_USER_SERVICE_URL +
      GET_DEPT_URL
    );
    yield put({ type: "GET-DEPT-REDUCER", payload: response.data.data });
  } catch (e) {
    if (e.message) {
      toast.error(e.message);
    } else toast.error("failed! please check conection");
  }
}

function* watchGetAllDepartments() {
  yield takeEvery("GET-DEPT", getAllDepartments);
}
function* getPureAllDepartments() {
  let response;
  try {
    response = yield AxiosInstance.get(REACT_APP_USER_SERVICE_URL +
      GET_DEPT_URL + "/all"
    );
    yield put({ type: "GET-PURE-DEPT-REDUCER", payload: response.data.data });
  } catch (e) {
    if (e.message) {
      toast.error(e.message);
    } else toast.error("failed! please check conection");
  }
}

function* watchGetPureAllDepartments() {
  yield takeEvery("GET-PURE-DEPT", getPureAllDepartments);
}
function* AddDepartments(action) {
  let responses;
  try {
    yield put({ type: "GENERAL-DONE-DEPT" });
    yield put({ type: "request-running-dept", payload: action.payload });
    yield AxiosInstance.post(REACT_APP_USER_SERVICE_URL +
      ADD_DEPT_URL,
      JSON.stringify(action.payload)
    );
    yield put({ type: "request-running-dept-red", payload: action.payload });
    setTimeout(() => {
      store.dispatch({ type: "request-running-dept-red", payload: null });
    }, 4000);
    yield put({ type: "GENERAL-DONE-DEPT" });
    responses = yield AxiosInstance.get(REACT_APP_USER_SERVICE_URL +
      GET_DEPT_URL
    );
    yield put({ type: "GET-DEPT-REDUCER", payload: responses.data.data });
  } catch (e) {
    yield put({
      type: "GENERAL-ERR-dept",
      payload: { data: action.payload, message: e.message },
    });
    if (e.message) {
      toast.error(e.message);
    } else toast.error("failed! please check conection");
  }
}

function* watchAddDepartments() {
  yield takeEvery("ADD-DEPT", AddDepartments);
}
function* UpdateDepartments(action) {
  let responses;
  try {
    yield put({ type: "GENERAL-DONE-DEPT" });
    yield put({ type: "request-running-dept", payload: action.payload });
    yield AxiosInstance.post(REACT_APP_USER_SERVICE_URL +
      UPD_DEPT_URL,
      JSON.stringify(action.payload)
    );
    yield put({ type: "request-running-dept-red", payload: action.payload });
    setTimeout(() => {
      store.dispatch({ type: "request-running-dept-red", payload: null });
    }, 4000);
    yield put({ type: "GENERAL-DONE-DEPT" });
    responses = yield AxiosInstance.get(REACT_APP_USER_SERVICE_URL +
      GET_DEPT_URL
    );

    yield put({ type: "GET-DEPT-REDUCER", payload: responses.data.data });
    yield put({ type: "GENERAL-DONE-DEPT" });
  } catch (e) {
    yield put({
      type: "GENERAL-ERR-dept",
      payload: { data: action.payload, message: e.message },
    });
    if (e.message) {
      toast.error(e.message);
    } else toast.error("failed! please check conection");
  }
}

function* watchUpdDepartments() {
  yield takeEvery("UPD-DEPT", UpdateDepartments);
}

export function* DepartmentsSaga() {
  yield all([
    fork(watchGetAllDepartments),
    fork(watchGetPureAllDepartments),
    fork(watchUpdDepartments),
    fork(watchAddDepartments),
  ]);
}
